import styled, { css } from 'styled-components';

import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const LandingTitle = styled.h1`
  display: inline-flex;
  flex-direction: column;
  font-size: clamp(43px, 4.8vw, 80px);
  font-weight: 400;
  text-transform: uppercase;
  max-width: 100%;
  text-align: center;
  @media ${laptopAndAbove} {
    font-size: 92px;
    &.left {
      text-align: left;
    }
  }
`;
const font = css`
  text-transform: uppercase;
  font-weight: 400;
  line-height: 1;
`;
export const LandingTitleS = styled.h2`
  ${font}
  font-size: clamp(27px, 4.8vw, 35px);
`;
export const LandingTitleM = styled.h2`
  ${font}
  font-size: clamp(27px, 4.8vw, 55px);
`;
export const LandingTitleL = styled.h2`
  ${font}
  font-size: clamp(37px, 4.8vw, 68px);
`;
